import Modal from '../addons/micro-modal';

declare global {
  const en: boolean;
}

declare var __ucCmp: any;

const youtTubeVideoId = 'BJz7qNsdj-7';

Modal.init({
  onShow: (modal: HTMLElement) => {
    modal.dispatchEvent(new CustomEvent('modalShow'));
  },
  onClose: (modal: HTMLElement) => {
    modal.dispatchEvent(new CustomEvent('modalClose'));
  },
  disableScroll: true,
  openTrigger: 'data-modal',
  closeTrigger: 'data-close'
});

async function getYoutubeConsent(): Promise<boolean> {
  return await getLatestServicesConsent([youtTubeVideoId]).then(data => data[youtTubeVideoId]);
}

export async function getLatestServicesConsent(services: string[]): Promise<{
  [service: string]: boolean;
}> {
  if (typeof __ucCmp === 'undefined') {
    return services.reduce(
      (consent, service) => {
        consent[service] = false;
        return consent;
      },
      {} as { [service: string]: boolean }
    );
  }
  const latestConsent = await __ucCmp.getConsentDetails();
  return services.reduce(
    (consent, service) => {
      consent[service] = !!latestConsent.services[service]?.consent?.given;
      return consent;
    },
    {} as { [service: string]: boolean }
  );
}

function createYoutubeModalIframe(): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.youtube-nocookie.com/embed/8VBv_1qQuD4';
  iframe.id = 'yt-player';
  iframe.width = '1280';
  iframe.height = '720';
  iframe.setAttribute('allowfullscreen', '');
  iframe.allow = 'autoplay';
  iframe.title = 'Youtube Video';
  iframe.name = 'videocontent';
  return iframe;
}

const youtubeModal = document.getElementById('youtube-modal');
const videoWrapper = youtubeModal?.querySelector('.videoWrapper');
if (youtubeModal && videoWrapper) {
  window.addEventListener('UC_UI_INITIALIZED', async () => {
    if (await getYoutubeConsent()) {
      const iframe = createYoutubeModalIframe();
      videoWrapper.appendChild(iframe);
    } else {
      window.addEventListener('UC_CONSENT', async () => {
        if (await getYoutubeConsent()) {
          const iframe = createYoutubeModalIframe();
          videoWrapper.appendChild(iframe);
        } else {
          const iframe = videoWrapper.querySelector('iframe');
          if (iframe) {
            videoWrapper.removeChild(iframe);
          }
        }
      });
    }
  });
}
const youtubeConsentModal = document.getElementById('youtube-consent-modal');

if (youtubeConsentModal) {
  youtubeConsentModal.querySelector('button.primary')?.addEventListener('click', e => {
    __ucCmp.updateServicesConsents([{ id: 'BJz7qNsdj-7', consent: true }]).then(() => {
      __ucCmp.saveConsents();
      Modal.close('youtube-consent-modal');
    });
  });

  youtubeConsentModal.querySelector('button.outline')?.addEventListener('click', e => {
    __ucCmp.showServiceDetails('BJz7qNsdj-7');
  });
}

// Youtube modal
document.querySelectorAll('[data-youtube]').forEach(elem => {
  elem.addEventListener('click', async e => {
    e.preventDefault();
    if (!(await getYoutubeConsent())) {
      Modal.show('youtube-consent-modal', { disableScroll: true, closeTrigger: 'data-close' });
      return;
    }

    //@ts-ignore
    localStorage.setItem('ytVideo', elem.dataset.youtube);
    Modal.show('youtube-modal', {
      onShow: (modal: HTMLElement) => {
        const iframe = modal.querySelector('iframe');
        if (iframe) {
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + localStorage.getItem('ytVideo') + '?autoplay=1';
        }
      },
      onClose: (modal: HTMLElement) => {
        const iframe = modal.querySelector('iframe');
        if (iframe) {
          iframe.src = 'https://www.youtube-nocookie.com/embed/8VBv_1qQuD4';
        }
      },
      closeTrigger: 'data-close'
    });
  });
});

function createMagYoutubeIframe(videoId = 'JhuKGXebQJU'): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.youtube.com/embed/' + videoId + '?rel=0&controls=1&showinfo=0';
  iframe.allow = 'autoplay; encrypted-media';
  iframe.setAttribute('allowfullscreen', '');
  iframe.title = 'Youtube Video';
  iframe.name = 'videocontent';
  return iframe;
}

function createYoutubeOverlay(videoId = 'JhuKGXebQJU'): HTMLImageElement {
  const img = document.createElement('img');
  img.src = 'https://privacy-proxy-server.usercentrics.eu/video/youtube/' + videoId + '-poster-image';

  return img;
}

function createConsentDiv(serviceTitle: string, serviceId: string): HTMLDivElement {
  const overlay = document.createElement('div');
  overlay.classList.add('consent-overlay');
  const consentElem = document.createElement('div');
  consentElem.innerHTML = `
    <span class="h4">${en ? `We need your consent to show this ${serviceTitle}` : `Wir benötigen deine Zustimmung, um ${serviceTitle} zeigen zu können`}</span>
    <p>${
      en
        ? 'This content is not permitted to load due to trackers that are not disclosed to the visitor. The website owner needs to setup the site with their CMP to add this content to the list of technologies used.'
        : 'Dieser Inhalt darf aufgrund von Trackern, die dem Besucher nicht offengelegt werden, nicht geladen werden. Der Website-Betreiber muss die Website mit seinem CMP einrichten, um diesen Inhalt zur Liste der verwendeten Technologien hinzuzufügen.'
    }</p>
    <div class="buttons">
      <button class="btn primary">${en ? 'Accept' : 'Annehmen'}</button>
      <button class="btn outline">${en ? 'More information' : 'Mehr Informationen'}</button>
    </div>
  `;
  consentElem.classList.add('consent-element');
  overlay.appendChild(consentElem);

  const acceptButton = consentElem.querySelector('.btn.primary');
  const moreInfoButton = consentElem.querySelector('.btn.outline');

  acceptButton?.addEventListener('click', () => {
    __ucCmp.updateServicesConsents([{ id: serviceId, consent: true }]).then(() => {
      __ucCmp.saveConsents();
    });
  });

  moreInfoButton?.addEventListener('click', () => __ucCmp.showServiceDetails(serviceId));

  return overlay;
}

function createMagYoutubePlayButton(): HTMLAnchorElement {
  const playButton = document.createElement('a');
  playButton.href = '';
  playButton.classList.add('btn-play');
  playButton.setAttribute('aria-label', en ? 'Play video' : 'Video abspielen');
  playButton.innerHTML = '<svg><use xlink:href="/assets/dist/sprite.svg#btn-play" /></svg>';
  return playButton;
}

document.querySelectorAll('.mag-image-block .magvid').forEach(videoElem => {
  const el = videoElem as HTMLElement;
  const videoId = el.dataset.videoUrl;

  const img = createYoutubeOverlay(videoId);
  const playButton = createMagYoutubePlayButton();
  el.appendChild(img);
  el.appendChild(playButton);

  playButton.addEventListener('click', async e => {
    e.preventDefault();
    if (!(await getYoutubeConsent())) {
      Modal.show('youtube-consent-modal', { disableScroll: true, closeTrigger: 'data-close' });
      return;
    }
    const iframe = createMagYoutubeIframe(videoId);
    el.appendChild(iframe);
    el.removeChild(img);
    el.removeChild(playButton);
  });
});

// Other services

let consentStore: {
  [service: string]: boolean;
} = {};

type Service = {
  serviceId: string;
  srcIdentifier: string[];
  consentTitle: string;
  consentGiven?: boolean;
  iframes: HTMLIFrameElement[];
};

const servicesWithConsent: Service[] = [
  {
    // Datawrapper
    serviceId: '8Nxb4ZtSa',
    srcIdentifier: ['datawrapper.'],
    consentTitle: en ? 'element' : 'dieses Element',
    iframes: []
  },
  {
    // Youtube
    serviceId: youtTubeVideoId,
    srcIdentifier: ['.youtube.'],
    consentTitle: en ? 'Youtube video' : 'dieses Youtube Video',
    iframes: []
  },
  {
    // Google Maps
    serviceId: 'S1pcEj_jZX',
    srcIdentifier: ['google', 'maps/embed'],
    consentTitle: en ? 'map' : 'diese Karte',
    iframes: []
  },
  {
    // Appinio
    serviceId: 'aVQhDPlnHpdqu5',
    srcIdentifier: ['.appinio.'],
    consentTitle: en ? 'element' : 'dieses Element',
    iframes: []
  }
];

const iframes = Array.from(document.querySelectorAll('iframe'));
const unknownIframes: HTMLIFrameElement[] = [];

function prepareOverlay(iframe: HTMLIFrameElement, consentElement: HTMLDivElement) {
  const iframeParent = iframe.parentElement;
  if (!iframeParent) {
    return;
  }
  iframeParent.style.position = 'relative';
  iframeParent.style.width = iframeParent.offsetWidth + 'px';
  iframeParent.style.height = iframeParent.offsetHeight + 'px';
  iframeParent.style.padding = '0';
  iframe.style.position = 'absolute';
  iframeParent.appendChild(consentElement);
}

iframes.forEach(iframe => {
  let iframeAssgined = false;
  servicesWithConsent.forEach(service => {
    if (service.srcIdentifier.every(identifier => iframe.dataset.src?.includes(identifier))) {
      service.iframes.push(iframe);
      iframeAssgined = true;
    }
  });
  if (!iframeAssgined) {
    unknownIframes.push(iframe);
  }
});

if (window.location.href.indexOf('localhost') > 0) {
  function createUnknownServiceIframeElement(iframe: HTMLIFrameElement) {
    const overlay = document.createElement('div');
    overlay.classList.add('consent-overlay');
    const consentElem = document.createElement('div');
    consentElem.innerHTML = `
    <span class="h4">${en ? 'This iframe is unknow yet' : 'Dieses IFrame ist noch unbekannt'}</span>
    <p>${
      en
        ? 'It seems this iframe is not connected to a service yet. Please get in touch with team LOKI and clarify if using it without user consent is fine.'
        : 'Es scheint, dass dieser iFrame noch nicht mit einem Dienst verbunden ist. Bitte setze dich sich mit Team LOKI in Verbindung und kläre, ob die Verwendung ohne Zustimmung des Benutzers in Ordnung ist.'
    }</p>
    <div class="buttons">
      <button class="btn primary">${en ? 'Show iframe' : 'iFrame anzeigen'}</button>
    </div>
  `;
    consentElem.classList.add('consent-element');
    overlay.appendChild(consentElem);

    const iframeParent = iframe.parentElement;
    if (!iframeParent?.querySelector('.consent-overlay')) {
      prepareOverlay(iframe, overlay);
    }

    const acceptButton = consentElem.querySelector('.btn.primary');

    acceptButton?.addEventListener('click', () => {
      iframe.src = iframe.dataset.src as string;
      if (iframeParent?.querySelector('.consent-overlay')) {
        iframeParent?.querySelector('.consent-overlay')?.remove();
      }
      iframeParent?.removeAttribute('style');
      iframe.style.removeProperty('position');
    });
  }

  if (unknownIframes.length > 0) {
    unknownIframes.forEach(iframe => {
      const src = iframe.dataset.src;
      if (!src) {
        return;
      }
      createUnknownServiceIframeElement(iframe);
    });
  }
}

// Set all services to accepted by default for test if uc is not loaded
if (window.location.href.indexOf('ottonova.de') < 0 && window.location.href.indexOf('loaduc=1') < 0 && sessionStorage.getItem('loaduc') !== 'true') {
  servicesWithConsent.forEach(service => {
    consentStore[service.serviceId] = true;
  });
  window.dispatchEvent(new CustomEvent('UC_CONSENT'));
}

window.addEventListener('UC_CONSENT', async () => {
  if (window.location.href.indexOf('ottonova.de') > 0 || window.location.href.indexOf('loaduc=1') !== -1 || sessionStorage.getItem('loaduc') === 'true') {
    consentStore = await getLatestServicesConsent(Object.values(servicesWithConsent).map(service => service.serviceId));
  }

  servicesWithConsent.forEach(service => {
    if (service.consentGiven !== consentStore[service.serviceId] && service.iframes) {
      service.consentGiven = consentStore[service.serviceId];
      service.iframes?.forEach(iframe => {
        const src = iframe.dataset.src;
        if (!src) {
          return;
        }

        const iframeParent = iframe.parentElement;
        const serviceConsentElement = createConsentDiv(service.consentTitle, service.serviceId);

        if (consentStore[service.serviceId]) {
          iframe.src = src;
          const consentOverlay = iframeParent?.querySelector('.consent-overlay');
          if (consentOverlay) {
            iframeParent?.removeChild(consentOverlay);
          }
          iframeParent?.removeAttribute('style');
          iframe.style.removeProperty('position');
        } else {
          iframe.src = '';
          if (serviceConsentElement && !iframeParent?.querySelector('.consent-overlay')) {
            prepareOverlay(iframe, serviceConsentElement);
          }
        }
      });
    }
  });
});
